export const bulkCalendarDrawer = {
  header: {
    eyebrow: "Édition groupée",
    title: "Calendrier groupé",
    subtitle: "Fermez, ouvrez ou ajustez plusieurs unités à la fois.",
  },
  actions: {
    close: {
      label: "Fermer des dates",
      hint: "Applique un blocage manuel tout en respectant les réservations et la synchronisation.",
    },
    open: {
      label: "Ouvrir des dates",
      hint: "Rouvre uniquement les jours sélectionnés sans toucher au reste du blocage.",
    },
    price: {
      label: "Modifier le prix",
      hint: "Met à jour le prix par nuit pour les dates et logements choisis.",
    },
    minStay: {
      label: "Séjour minimum",
      hint: "Définissez le nombre minimum de nuits par date en masse.",
    },
  },
  microcopy: {
    close: "Blocage manuel",
    open: "Ouverture partielle",
    price: "Tarif par nuit",
    minStay: "Nuits minimum",
  },
  step1: {
    title: "Que faut-il appliquer",
    hintEmpty: "Choisissez une action pour commencer.",
  },
  step2: {
    title: "Où l'appliquer",
    selectedCount: "{selected} sur {total} sélectionnés",
    selectVisible: "Visibles",
    selectAll: "Tous",
    clear: "Effacer",
    searchPlaceholder: "Rechercher un logement…",
    empty: "Aucun logement ne correspond à votre recherche.",
  },
  step3: {
    title: "Période et jours",
    datesInRange: "{count} date dans la période | {count} dates dans la période",
    from: "Du",
    to: "Au",
    presetAll: "Tous",
    presetWeekdays: "Lun–Ven",
    presetWeekend: "Week-end",
  },
  step4: {
    closeReasonTitle: "Motif de fermeture",
    availabilityTitle: "Disponibilité",
    closeReasonHint: "Facultatif — il sera enregistré avec le blocage.",
    availabilityHint: "Les ventes sont fermées (stop-sell) ; la disponibilité est conservée. Ne la modifiez que si vous le souhaitez.",
    closeCommentPlaceholder: "ex. maintenance ou usage du propriétaire",
    availabilityPlaceholder: "Chambres en vente (vide = conserver)",
    openAvailabilityHint: "Rouvre les ventes. Indiquez combien de chambres proposer (vide = conserver l'actuel).",
    availabilityPlaceholderOpen: "Chambres en vente",
  },
  ratePlan: {
    title: "Tarif à modifier",
    hint: "Ce type comporte plusieurs tarifs. Choisissez le(s)quel(s) appliquer {target}. Les tarifs dérivés s'ajustent automatiquement.",
    targetPrice: "au prix",
    targetMinStay: "au séjour minimum",
    default: "standard",
    roomsCount: "{count} chambre | {count} chambres",
    multiUnitNote: "Cela s'appliquera à chaque chambre disposant du tarif choisi.",
    fallbackName: "Tarif",
  },
  price: {
    title: "Nouveau prix par nuit",
    hint: "Cela s'appliquera aux dates, unités et tarifs choisis.",
    mixedCurrencyWarning: "Sélectionnez uniquement des logements ayant la même devise.",
    placeholder: "Valeur",
    placeholderCurrency: "Valeur en {currency}",
    hintPercent: "Augmente ou baisse le prix déjà en place pour chaque nuit.",
    modeGroupLabel: "Type de modification du prix",
    modeFixed: "Prix fixe",
    modeFixedHint: "Le même montant pour toutes les nuits.",
    modePercent: "Pourcentage",
    modePercentHint: "Sur le prix de chaque nuit.",
    modeAmount: "Montant",
    modeAmountHint: "Ajouter ou retirer sur chaque nuit.",
    amountPlaceholder: "Ex. 10",
    amountHint: "S’ajoute à ce que coûte déjà chaque nuit. Le signe − fait baisser.",
    percentPlaceholder: "Ex. 20",
    percentHint: "Chaque nuit est recalculée à partir de son propre prix. Le signe − fait baisser (entre {min} % et {max} %).",
    toggleSign: "Basculer entre augmenter et baisser",
    invalidPercent: "Saisissez un pourcentage entre {min} % et {max} %, différent de 0.",
  },
  minStay: {
    title: "Séjour minimum",
    hint: "Nombre minimum de nuits par date.",
    placeholder: "ex. 2",
  },
  summary: {
    empty: "Sélectionnez des unités et une période.",
    unitOne: "unité",
    unitMany: "unités",
    dateOne: "date",
    dateMany: "dates",
    ready: "{propertyCount} {propertyLabel} · {dateCount} {dateLabel} prêtes à appliquer.",
    nightOne: "nuit",
    nightMany: "nuits",
    readyPriceFixed: "{propertyCount} {propertyLabel} · appliquera {price} {currency} sur {dateCount} {nightLabel}.",
    readyPricePlus: "{propertyCount} {propertyLabel} · augmentera de {amount} {currency} le prix de {dateCount} {nightLabel}.",
    readyPriceMinus: "{propertyCount} {propertyLabel} · baissera de {amount} {currency} le prix de {dateCount} {nightLabel}.",
    readyPriceUp: "{propertyCount} {propertyLabel} · augmentera de {percent} % le prix de {dateCount} {nightLabel}.",
    readyPriceDown: "{propertyCount} {propertyLabel} · baissera de {percent} % le prix de {dateCount} {nightLabel}.",
  },
  footer: {
    cancel: "Annuler",
    apply: "Appliquer les modifications",
    applying: "Application…",
  },
  weekdays: {
    mon: { short: "L", long: "Lundi" },
    tue: { short: "M", long: "Mardi" },
    wed: { short: "M", long: "Mercredi" },
    thu: { short: "J", long: "Jeudi" },
    fri: { short: "V", long: "Vendredi" },
    sat: { short: "S", long: "Samedi" },
    sun: { short: "D", long: "Dimanche" },
  },
  ownerBlockComment: "Bloqué par le propriétaire",
};
